module.exports = __webpack_public_path__ + "img/loto_vert_color.c78b1c4b.png";